import {
  doc,
  getDoc,
  getDocs,
  collection,
  query,
  limit,
  updateDoc,
  orderBy,
  startAfter,
  getCountFromServer,
  where,
  documentId,
} from "firebase/firestore";
import { db } from "config/firebase";

const getDocument = (id) => {
  return doc(db, "promises", id);
};

export const getData = async (reference) => {
  if (reference) {
    const docSnap = await getDoc(reference);
    return docSnap.exists ? { id: docSnap?.id, ...docSnap.data() } : null;
  }
  return null;
};

export const getPromises = async (last, filters = {}) => {
  const orderByField = filters?.order?.orderBy || "createdAt";
  const orderDirection = filters?.order?.direction || "desc";

  try {
    // Build the base query
    let q = query(
      collection(db, "promises"),
      orderBy(orderByField, orderDirection),
      ...(last ? [startAfter(last)] : []),
      limit(10),
    );

    // Conditionally add filter categories
    if (!!filters.categories?.length) {
      q = query(
        q,
        where("categories", "array-contains-any", filters.categories),
      );
    }

    // Conditionally add filter predictorId
    if (!!filters.predictorId) {
      q = query(q, where("predictor.id", "==", filters.predictorId));
    }

    // Conditionally add filter finished
    if (!!filters.finished) {
      q = query(q, where("type", "==", "finished"));
    }

    const documentSnapshots = await getDocs(q);

    // Get the last visible document
    const lastVisible =
      documentSnapshots.docs[documentSnapshots.docs.length - 1];

    const promises = documentSnapshots.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));

    // Build the query for the total count
    let queryCount = query(collection(db, "promises"));

    if (!!filters.categories?.length) {
      queryCount = query(
        queryCount,
        where("categories", "array-contains-any", filters.categories),
      );
    }

    if (!!filters.predictorId) {
      queryCount = query(
        queryCount,
        where("predictor.id", "==", filters.predictorId),
      );
    }

    if (!!filters.finished) {
      queryCount = query(queryCount, where("type", "==", "finished"));
    }

    const countSnapshot = await getCountFromServer(queryCount);
    const totalPromisesCount = countSnapshot.data().count;

    // Return promises, last document, and total count of promises
    return { promises, last: lastVisible, totalPromisesCount };
  } catch (error) {
    console.error(`Error while getting promises: ${error}`);
    return error;
  }
};

export const getPromiseById = async (id) => {
  const docRef = getDocument(id);
  const docSnap = await getDoc(docRef);
  const promise = docSnap.data();
  return docSnap.exists
    ? { id: docSnap.id, ...promise, category: [], reviewers: [] }
    : null;
};

export const updatePromises = async (id, data) => {
  try {
    await updateDoc(getDocument(id), data);
  } catch (e) {
    console.error(`Error while updating promise ${e}`);
    return false;
  }
};

export const getPromisesByIds = async (ids) => {
  const q = query(collection(db, "promises"), where(documentId(), "in", ids));
  const querySnapshot = await getDocs(q);
  const promises = querySnapshot.docs.map((doc) => {
    return { ...doc.data(), id: doc.id };
  });
  return promises;
};
